import Component from '@glimmer/component';

import { service } from '@ember/service';

import ErrorContact from 'rise-ui/components/error-contact.gjs';
import ErrorPage from 'rise-ui/components/error-page.gjs';
import concatClasses from 'rise-ui/helpers/concat-classes.js';
import one from 'rise-ui/helpers/one.js';
import titleCase from 'rise-ui/helpers/title-case.js';
import { readOnly } from 'rise-ui/utils/object/computed.js';

export default class PageNotFoundComponent extends Component {
  @service('page-not-found-model') pageNotFoundModel;

  @readOnly('pageNotFoundModel.model') model;

  <template>
    {{#let (one this.model.name "page") as | modelName |}}
    <ErrorPage class={{concatClasses "qa-error-page-not-found" this.model.class}} as | error |>
      <error.title>
        {{yield to="title"}}
        {{#unless (has-block "title")}}
          {{titleCase modelName}} Not Found
        {{/unless}}
      </error.title>
      <error.subtitle>
        {{yield to="subtitle"}}
        {{#unless (has-block "subtitle")}}
          We're sorry, but that {{modelName}} could not be found.
        {{/unless}}
      </error.subtitle>
      <error.content>
        {{yield to="content"}}
        {{#unless (has-block "content")}}
          <ErrorContact />
        {{/unless}}
      </error.content>
    </ErrorPage>
    {{yield}}
    {{/let}}
  </template>
}
